// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var HighlightSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ConversationPageSelectedConversationAnonymousControl_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationAnonymousControl_conversation_graphql.bs.js");
var ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql = require("../../../__generated__/ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.bs.js");

var convertFragment = ConversationPageSelectedConversationAnonymousControl_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationAnonymousControl_conversation_graphql.node, convertFragment, fRef);
}

var ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.Internal.convertVariables;

var convertResponse = ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, ConversationPageSelectedConversationAnonymousControl_DeanonymizeConversationMutation_graphql.node, convertResponse, convertWrapRawResponse);

var DeanonymizeConversationMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function ConversationPageSelectedConversationAnonymousControl(props) {
  var conversationId = props.conversationId;
  var conversation = use(props.conversation);
  var anonymous = Core__Option.getOr(conversation.anonymous, false);
  var match = use$1();
  var deanonymizeConversation = match[0];
  var currentUserId = AuthSession.useCurrentUserId();
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowConfirmation = match$1[1];
  var openDialog = function (param) {
    setShowConfirmation(function (param) {
          return true;
        });
  };
  var closeDialog = function (param) {
    setShowConfirmation(function (param) {
          return false;
        });
  };
  var match$2 = SystemMessages.useSystemMessages();
  var addMessage = match$2.addMessage;
  var showErrorMessage = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem sharing your information", 5000, undefined, undefined));
  };
  var handleShareIdentity = function (param) {
    setShowConfirmation(function (param) {
          return false;
        });
    if (conversationId !== undefined) {
      deanonymizeConversation({
            conversationId: conversationId
          }, undefined, undefined, undefined, (function (response, _mutationErrors) {
              var match = response.deanonymizeConversation;
              if (match !== undefined && match.__typename === "ConversationWasDeanonymized") {
                return ;
              } else {
                return showErrorMessage();
              }
            }), (function (param) {
              showErrorMessage();
            }), undefined);
      return ;
    }
    
  };
  var match$3 = conversation.conversationContext;
  var ownerAgentId;
  if (match$3 !== undefined && match$3.__typename === "AvailableConversationContext") {
    var match$4 = match$3.context;
    if (match$4 !== undefined) {
      switch (match$4.__typename) {
        case "ForSalePropertyV5" :
            var match$5 = match$4.agentV2;
            if (match$5 !== undefined && match$5.__typename === "VisibleForSalePropertyAgent") {
              var match$6 = match$5.agent;
              ownerAgentId = match$6 !== undefined ? match$6.id : undefined;
            } else {
              ownerAgentId = undefined;
            }
            break;
        case "RentalPropertyV5" :
            var match$7 = match$4.agent;
            ownerAgentId = match$7 !== undefined ? match$7.id : undefined;
            break;
        case "__unselected" :
            ownerAgentId = undefined;
            break;
        
      }
    } else {
      ownerAgentId = undefined;
    }
  } else {
    ownerAgentId = undefined;
  }
  if (anonymous && ownerAgentId !== undefined && currentUserId !== undefined && currentUserId === ownerAgentId) {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx(DialogV5.make, {
                        title: "Share information?",
                        isOpen: match$1[0],
                        ariaLabel: "Are you sure?",
                        onDismiss: closeDialog,
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: "This action cannot be undone."
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                              onClick: closeDialog,
                                              children: "Cancel"
                                            }),
                                        JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                                              onClick: handleShareIdentity,
                                              children: "Yes, share my identity"
                                            })
                                      ],
                                      className: "flex flex-row justify-center space-x-4"
                                    })
                              ],
                              className: "flex flex-col items-center space-y-4"
                            })
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(HighlightSection__Jsx3.make, {
                              children: Caml_option.some(JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: "You are anonymous to other users in this conversation."
                                              }),
                                          conversationId !== undefined ? JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                                        onClick: openDialog,
                                                        children: "Share my identity"
                                                      })
                                                }) : null
                                        ],
                                        className: "flex flex-col items-center space-y-2"
                                      }))
                            }),
                        className: "p-4"
                      })
                ]
              });
  } else {
    return null;
  }
}

var make = ConversationPageSelectedConversationAnonymousControl;

exports.ConversationFragment = ConversationFragment;
exports.DeanonymizeConversationMutation = DeanonymizeConversationMutation;
exports.make = make;
/* commitMutation Not a pure module */
